// todo Update import path when lib is updated
import { Language } from '@3ddv/ngx-sites-builder-lib/lib/services/tools/language/interfaces/language-tool.interface';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToolsService } from '../services/tools.service';
import { Subscription } from 'rxjs';
import { SblibService } from '../../services/sblib.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss']
})
export class LanguageComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public tool: Language;
  public languageCodes: string[];

  constructor(
    private toolsService: ToolsService,
    private sblibService: SblibService,
    private toastrService: ToastrService
  ) {
    this.subscriptions = [];
    this.languageCodes = ['ca', 'es', 'en', 'pt', 'it', 'de', 'no'];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.language) {
        this.tool = JSON.parse(JSON.stringify(res.language));
      } else {
        console.error('language tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public apply() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      res.language = JSON.parse(JSON.stringify(this.tool));
      this.sblibService.apply(res);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(tools$);
  }

}
